import React from 'react';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { WhatYouCreate } from './components/WhatYouCreate';
import { ProblemAgitation } from './components/ProblemAgitation';
import { ProductReveal } from './components/ProductReveal';
import { Bonuses } from './components/Bonuses';
import { UrgencyBlock } from './components/UrgencyBlock';
import { PricingCard } from './components/PricingCard';
import { WhyItWorks } from './components/WhyItWorks';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostOfNotStarting } from './components/CostOfNotStarting';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
import { ImageMarquee } from './components/ImageMarquee';
export function App() {
  return <div className="min-h-screen bg-slate-50 font-sans selection:bg-brand-200 selection:text-brand-900" data-id="element-0">
      <CountdownBar data-id="element-1" />
      <PurchasePopup data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <SocialProof data-id="element-5" />
        <ImageMarquee data-id="element-6" />
        <WhatYouCreate data-id="element-7" />
        <ProblemAgitation data-id="element-8" />
        <ProductReveal data-id="element-9" />
        <Bonuses data-id="element-10" />
        <ImageMarquee images={['https://cdn.magicpatterns.com/uploads/iZF8YCoq45Kv55ZSknFhak/WhatsApp_Image_2026-05-26_at_1.39.04_PM_(1).jpg', 'https://cdn.magicpatterns.com/uploads/u4t4nVHtGNn7gkaJRtHe4J/WhatsApp_Image_2026-05-26_at_1.39.04_PM.jpg', 'https://cdn.magicpatterns.com/uploads/vxBVV5kpAoJuCh1R5qKBkT/WhatsApp_Image_2026-05-26_at_1.39.03_PM_(1).jpg', 'https://cdn.magicpatterns.com/uploads/d6JMED3mxoxrHSuGSaMxqp/WhatsApp_Image_2026-05-26_at_1.39.03_PM.jpg', 'https://cdn.magicpatterns.com/uploads/wkNpCkfL91wmSi34LdeYTp/312262838_167866455911015_785360200146221973_n-1.jpg']} label="🐾 También para gatitos — diseños suaves y elegantes" reverse={true} background="bg-brand-50" data-id="element-11" />
        <UrgencyBlock data-id="element-12" />
        <PricingCard data-id="element-13" />
        <WhyItWorks data-id="element-14" />
        <Testimonials data-id="element-15" />
        <Guarantee data-id="element-16" />
        <FAQ data-id="element-17" />
        <CostOfNotStarting data-id="element-18" />
        <FinalCTA data-id="element-19" />
      </main>
      <Footer data-id="element-20" />
    </div>;
}